import { VApp } from 'vuetify/lib/components/VApp';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticClass:"mx-auto",style:({ background: 'transparent' })},[_c(VImg,{staticClass:"mx-auto",attrs:{"src":_vm.modulo_src,"height":"100","width":"800","contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }